import { BasicClient } from "@/utils/httpClient";

interface ISearchParams {
  bypage?: number;
  idTemplates?:string;
  page?: number;
  nombre?: string;
  pickup?: number;
  estado?: number;
}

interface IEformParams {
  iddoc: string,
  nombre?: string,
  estado?: string
}

export default class Eforms {
  client: BasicClient;
  constructor() {
    this.client = new BasicClient();
  }
  getList(): any {
    return this.client.exec("/eforms/", "GET");
  }
  EformById(id): any {
    return this.client.exec("/eforms/packages/" + id, "GET");
  }
  getEformTemplates() {
    return this.client.exec("/eforms/packages", "GET", {
      bypage: 500,
      order: "id",
      criteria: "desc",
      filter: '[{"key":"state","value":"1","operator":"="}]'
    });
  }
  getTemplateList(params: ISearchParams) {
    return this.client.exec(`/eforms/templates/list`, "GET", params);
  }

  getPackagesList(value: string) {
    return this.client.exec("/eforms/packages", "GET", {
      filter: `[{"key":"belongToDoc","value":${value},"operator":"in"}]`
    });
  }

  getEformThumbnail(iddoc: string) {
    return this.client.renderImage(`/eforms/preview/${iddoc}`);
  }

  updateEform(params: IEformParams) {
    const { iddoc, ...rest } = params
    return this.client.exec(`/eforms/templates/${iddoc}`, 'PUT', rest)
  }
  getPublishedEforms(limit, page, params) {
    let orderBy = '';
    let orderType = '';
    let filters = '';
    const pagination = '?pagination='+limit+','+page+',0';
    if(params && params.orders && params.orders.orderBy){
      orderBy = `&orderBy=${params.orders.orderBy}`; 
    }
    if(params && params.orders && params.orders.orderType){
      orderType = `&orderType=${params.orders.orderType}`; 
    }
    if(params && params.filters){
      filters = params.filters;
    }
    return this.client.exec(`/v2/admin-mod/eforms/published/search${pagination}${orderBy}${orderType}`, 'POST', filters);
  }
  updatePublishedEforms(id){
    return this.client.exec(`/v2/admin-mod/eforms/published/${id}/revert`, 'PUT');
  }
  getEformsPublishedRecipients(idMaster) {
    return this.client.exec(`/v2/admin-mod/eforms/published/${idMaster}/recipients`, 'GET');
  }
  getEformsSenders() {
    return this.client.exec(`/v2/admin-mod/eforms/senders`, 'GET');
  }
}
